const Steps = {
  AccountInfoForm: 0,
  ChangePasswordForm: 1,
  ChangePasswordSuccessfully: 2,
}

export default Steps
